const zenPopup = Object.freeze({
  illustration: 'balls',
  illustrationTransform: {
    x: '-39.55%',
    y: '-55.24%',
  },
  illustrationSizes: [
    { until: 's', value: 60, },
    { from: 's', until: 'l', value: 70, },
    { from: 'l', until: 'xl', value: 80, },
    { from: 'xl', value: 85, },
  ],
  textColor: 'neutral',
  textWidth: [
    { until: 's', value: '35rem', },
    { from: 's', until: 'l', value: '40rem', },
    { from: 'l', value: '45rem', },
  ],
  fontStack: 'commercial',
  titleType: [
    { until: 's', value: 2, },
    { from: 's', until: 'l', value: 3, },
    { from: 'l', value: 4, },
  ],
  subtitleType: [
    { until: 's', value: -1, },
    { from: 's', until: 'l', value: 0, },
    { from: 'l', value: 1, },
  ],
});

export default zenPopup;
